import "leaflet/dist/images/layers-2x.png"
import "leaflet/dist/images/layers.png"
import "leaflet/dist/images/marker-icon-2x.png"
import "leaflet/dist/images/marker-icon.png"
import "leaflet/dist/images/marker-shadow.png"
import "leaflet-draw/dist/images/spritesheet-2x.png"
import "leaflet-draw/dist/images/spritesheet.png"
import "leaflet-draw/dist/images/spritesheet.svg"

import "leaflet/dist/leaflet.css";

import L from "leaflet";
import "leaflet-draw"
import "../styles/leaflet-draw.css"

import defaultMarker from "../images/marker.png";

import {debounce, getCookie} from './util.js'

function setupMapPage() {
  $(document).ready(function() {
    if ($("#locator-map").length <= 0) return;

    const map = L.map("locator-map").setView(getStartingCenter(), 9.5);
    window.map = map

    map.on('moveend', debounce(_ => replaceLocationList(map), 400))

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    addLocationsToMap(map)
    getMapLines().then(data => addBywaysToMap(map, data))
    // createBywayControl(map)

    $('#category-select').on('change', e => {
      location.href = e.target.value
    })
  })
}

function setupMapLineDrawer(inputName) {

  window.getVal = () => $(`input[name~="${inputName}"]`).val()
  window.getJsVal = () => JSON.parse(getVal())

  let $colorInput = $(`input[name="map_line_color"]`)
  window.getColor = () => $colorInput.val() || 'rgba(200, 48, 89, .85)'

  $(document).ready(function() {
    if ($(`#locator-map-${inputName}`).length <= 0) return;
    let $input = $(`input[name="${inputName}"]`)
    $input.css({display: 'none'})

    const map = L.map(`locator-map-${inputName}`).setView(getStartingCenter(), 9.5);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    let editableLayer = addDrawControl(map, getColor(), getJsVal())
    function setInputVal() {
      $input.val(JSON.stringify(
        Object.values(editableLayer._layers)
          .map(layer => layer._latlngs.map(({ lat, lng }) => [lat, lng]))))
    }
    map.on(L.Draw.Event.CREATED, setInputVal)
    map.on(L.Draw.Event.EDITED, setInputVal)
    $colorInput.on('change', function() {
      let color = getColor()
      Object.values(editableLayer._layers).forEach(line => line.setStyle({color}))
    })
  })
}

function getStartingCenter() {
  let defaultCenter = [36.2337603587915, -81.06948852539064]
  try {
    var centerData = JSON.parse(document.querySelector('#starting-center').textContent)
    return centerData ? [centerData.lat, centerData.lng] : defaultCenter
  } catch {
    return defaultCenter
  }
}

function addBywaysToMap(map, byways) {
  return Object.fromEntries(
    byways.map(line => [
      line.name,
      createBywayLayer(line).addTo(map)
    ]))
}

function addLocationsToMap(map) {
  const locations = $(".locator-location");
  let oldMarkers = window.markers || {}
  window.markers = {}
  locations.each(function() {
    const data = $(this).data();
    let key = markerKey(data)
    if (!isNull(data.lat) && !isNull(data.lon) && data.showMapMarker) {
      let marker;
      // create a new marker if necessary
      if (oldMarkers[key]) {
        window.markers[key] = oldMarkers[key]
      } else {
        marker = L.marker([data.lat, data.lon],
                          { icon: makeIcon(data), title: data.name })
        marker
          .addTo(map)
          .bindPopup(mapConfig.mapPopupTemplate({...data, key }))
          .on("click", () => selectLocation(data.id))
        window.markers[key] = marker
      }
    }
    $(this).on("click", _ => {selectLocation(data.id);
                              });
  })

  // remove markers that are no longer in view of the map
  Object.keys(oldMarkers).forEach(key => {
    if (!window.markers[key]) {
      oldMarkers[key].remove()
    }
  })
}

let prevSelectedId = null
function selectLocation(id) {
  let locationEl = getLocation(id)
  if (!locationEl) return
  locationEl.classList.add("locator-location-active")
  $('.locator-location-active').removeClass("locator-location-active")
  let data = $(locationEl).data()
  window.mapLayers = window.mapLayers || {}


  if (prevSelectedId) {
    let prevLineGroup = window.polylineGroups[prevSelectedId]
    prevLineGroup && Object.values(prevLineGroup._layers).forEach(line => line.setStyle({weight: 5}))
  }
  let marker = window.markers[markerKey(data)]
  marker && marker.openPopup()

  let layerGroup = window.polylineGroups[id]
  let polylines = Object.values(layerGroup._layers)
  if (polylines && polylines[0]) {
    polylines.forEach(line => {
      line.setStyle({weight: 10})
      line.bringToFront()
    })
    if (!isNull(data.lat) && !isNull(data.lon)) {
      polylines[0].openPopup(mapConfig.mapPopupTemplate({...data, key: data.id}))
    } else {
      polylines[0].openPopup()
    }
  }

  $(locationEl).get(0).scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "start"
  })

  prevSelectedId = id
}

function replaceLocationList(map) {
  let bounds = map.getBounds()
  let center = map.getCenter()
  let searchParams = new URLSearchParams(location.search)
  fetch("/locations/list/",
        {method: 'POST',
         body: JSON.stringify({bounds, center, category: searchParams.get("category") || window.category}),
         credential: 'include',
         headers: {
           "Content-Type": "application/json",
           "X-CSRFToken": getCookie('csrftoken')
         }})
    .then(res => res.text())
    .then(html => {
      document.querySelector('#locator-list').innerHTML = html
      // maintain selection even if map move caused location list to re-render
      let popup = $('.leaflet-popup-content .tooltip-details').get(0)
      if (popup) {
        $('.locator-location').each(function() {
          let $this = $(this)
          if (markerKey($this.data()) == popup.dataset.key) {
            $this.addClass('locator-location-active')
            this.scrollIntoView({behavior: "smooth",
                                 block: "nearest",
                                 inline: "start"})
          }
        })
      }
    })
    .then(_ => addLocationsToMap(map))
    .catch(console.error)
}

function getMapLines() {
  return fetch("/locations/map_lines/").then(res => res.json()).then(data => data.data)
}

function createBywayControl(byways, map) {
  L.control.layers(
    {}, //base layers
    byways,
    {collapsed: false}
  ).addTo(map)
}

function makeIcon(data) {
  return L.icon({
    iconUrl: data.marker || defaultMarker,
    iconSize: [30, 30],
    iconAnchor: [23, 23],
    popupAnchor: [0, -23]
  })
}

function markerKey(data) {
  return `${data.name} (${data.lat} ${data.lon})`
}

function getLocation(id) {
  return document.querySelector(`.locator-location[data-id="${id}"]`)
}

function createBywayLayer(data) {
  let { name, color, description, map_line_data, id, weight = 5 } = data
  window.polylineGroups = window.polylineGroups || {}
  let group = L.layerGroup(map_line_data.map(line => {
    let polyline = L.polyline(line, {color, weight})
        .bindTooltip(`<p style="max-width: 80ch;">${name}</p>`)
        .on('click', _ => selectLocation(id))

    polyline.bindPopup(mapConfig.mapPopupTemplate({...data, key: markerKey(data)}))
    return polyline
  }))
  window.polylineGroups[id] = group
  return group
}

function addLine(layerGroup, name, lineData, opts = {}) {
  opts.color = opts.color || '#000000';
  opts.weight = opts.weight || 3
  layerGroup.addLayer(L.polyline(lineData, opts))
}

function addDrawControl(map, color, initialData) {
  let editableLayer = new L.FeatureGroup()
  map.addLayer(editableLayer)
  window.editableLayer = editableLayer

  if (initialData) {
    initialData.forEach(line => addLine(editableLayer, '', line, {color}))
  }

  let control = new L.Control.Draw({
    position: 'topright',
    draw: {
      polyline: { shapeOptions: { color: color || '#f357a1',
                                  weight: 3 }},
      polygon: false,
      circle: false,
      rectangle: false,
      marker: false,
      featureGroup: editableLayer,
      circlemarker: false,
    },
    edit: { featureGroup: editableLayer,
            remove: false }
  })
  map.addControl(control)
  map.on(L.Draw.Event.CREATED, e => {
    editableLayer.addLayer(e.layer)
  })
  return editableLayer
}

function isNull(val) {return !val || val == "None"}

Object.assign(
  window,
  {addLine, createBywayControl, addDrawControl, setupMapPage, setupMapLineDrawer}
)
